import errorCode from "@/const/errorCode"
import router from "@/router"
import useConfigStore from "@/stores/config"
import useUserStoreHook from "@/stores/user"
import axios from "axios"
import { ElMessage, ElMessageBox } from "element-plus"
import NProgress from "nprogress"
import Qs from 'qs'

function getData() {}

let messageInstance: any = null

function formatDict(data: any, dict: any) {
    Object.keys(dict).forEach((item) => {
        const dictData = dict[item]
        const keyData = data
        const keys = item.split(".")

        const recu = (keyIndex: number, data: any) => {
            const key = keys[keyIndex]
            if (!data) return null
            if (Array.isArray(data)) {
                data.forEach((row: number) => {
                    recu(keyIndex, row)
                })
            } else {
                if (keyIndex + 1 === keys.length) {
                    if (Array.isArray(data[key])) {
                        data[key + "Dict"] = {}
                        data[key].forEach((id: number) => {
                            data[key + "Dict"][id] = dictData[id]
                        })
                    } else {
                        data[key + "Dict"] = dictData[data[key]]
                    }
                } else {
                    recu(keyIndex + 1, data[key])
                }
            }
        }
        recu(0, keyData)
    })
    return data
}

function createRequest(uri: string) {
    const service = axios.create({
        baseURL: uri,
        timeout: 30000,
        paramsSerializer: function (params) {
            return Qs.stringify(params, {
                arrayFormat: 'comma',
                encode: true
            })
        },
    })

    // 请求拦截器
    service.interceptors.request.use(
        (config) => {
            // console.log(config, "=== config1111 ==")
            if (!config.headers) {
                throw new Error(`错误信息`)
            }
            const user = useUserStoreHook()
            const configStore = useConfigStore()
            if (!config.headers.Authorization && user.token) {
                // console.log(user.tenantId, '=== user.tenantId111 ==');
                ;(config.headers as any).Authorization = user.token
            }
            if (!config.headers["TENANT-ID"]) {
                ;(config.headers as any)["TENANT-ID"] = user.tenantId
                ;(config.headers as any)["TENANT-CODE"] = user.tenantCode
            }
            if (!config.headers["SERVICE-CODE"]) {
                ;(config.headers as any)["SERVICE-CODE"] = process.env.VUE_APP_SERVICE_CODE
            }
            if (!config.headers.notLoading) {
                configStore.updateRequestLoading(1)
            }
            return config
        },
        (error: any) => {
            return Promise.reject(error)
        }
    )

    // 响应拦截器
    service.interceptors.response.use(
        (response) => {
            NProgress.done()
            const status = Number(response.status) || 200
            const message =
                response.data.msg || errorCode[status] || errorCode["default"]

            if (!response.headers.notLoading) {
                const configStore = useConfigStore()
                configStore.updateRequestLoading(-1)

                if (response.data.code !== 200) {
                    configStore.clearRequestLoading()
                }
            }

            // 后台定义 424 针对令牌过去的特殊响应码
            if (status === 424) {
                ElMessageBox.confirm(
                    "登录状态已过期，请点击重新登录",
                    "系统提示",
                    {
                        confirmButtonText: "重新登录",
                        type: "warning",
                        callback: () => {
                            useUserStoreHook()
                                .logout()
                                .then(() => {
                                    // 刷新登录页面，避免多次弹框
                                    window.location.reload()
                                })
                        }
                    }
                )
                return
            }
            if (status !== 200 || response.data.code == 1) {
                ElMessage({
                    message: message,
                    type: "error"
                })
                return Promise.reject(new Error(message || "Error"))
            }
            // 文件流获取接口返回 response.data
            if (typeof response.data !== "object") {
                return response.data
            }
            if (!Reflect.has(response.data, "data")) {
                return response.data
            }
            return response.data.dictData
                ? formatDict(response.data.data, response.data.dictData)
                : response.data.data
        },
        (error: any) => {
            const user = useUserStoreHook()
            const status = Number(error.response.status)
            const message =
                error.response.data.msg || errorCode[status] || "系统错误"
            // 限制错误信息只弹出一次
            if (messageInstance) return
            messageInstance = message
            setTimeout(() => {
                messageInstance = null
            }, 1500)
            // 错误时清除loading
            const configStore = useConfigStore()
            configStore.clearRequestLoading()

            // 后台定义 424 针对令牌过去的特殊响应码
            if (status === 424) {
                ElMessageBox.alert(
                    "登录状态已过期，请点击重新登录",
                    "系统提示",
                    {
                        confirmButtonText: "重新登录",
                        type: "warning",
                        callback: async () => {
                            try {
                                await user.logout()
                            } catch (err) {
                                console.log(err)
                            }
                            // 刷新登录页面，避免多次弹框
                            window.location.reload()

                            router.push({
                                path: "/login"
                            })
                        }
                    }
                )
                return
            } else {
                if(!error.response?.config?.noErrorLoading) {
                    ElMessage({
                        message: message,
                        type: "error"
                    })
                }
            }
            return Promise.reject(new Error(error))
        }
    )
    return service
}

const request = createRequest(process.env.VUE_APP_BASE_API + "/api")
export default request

// async get(
//     url: string,
//     config?: AxiosRequestConfig<any>,
//     format?: {
//         labelKey: string
//         valueKey: string
//     }
// ) {
//     const data = await request.get(url, config)
//     if (format) {
//         const labelKeyReg = new RegExp(`"(${format.labelKey})"`)
//         const valueKeyReg = new RegExp(`"(${format.valueKey})"`)
//         return JSON.parse(
//             JSON.stringify(data)
//                 .replace(labelKeyReg, "label")
//                 .replace(valueKeyReg, "value")
//         )
//     }
//     return data
// }
